export function useHtmlSafe(text: string): string {
    if (!text) return '';
    // Escape HTML
    const escaped = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    // Replace newlines with <br>
    return escaped.replace(/\n/g, '<br>');
}